export default "__VITE_ASSET__DIoc2N8g__"